export default {
  items: [
    {
      name: '通知・発報履歴一覧',
      url: '/alertHistory',
      icon: 'fa fa-bell',
    },
    {
      name: '状態確認',
      url: '/monitoring',
      icon: 'fa fa-check-square',
    },
    {
      name: '踏切情報設定',
      url: '/railroadCrossing',
      icon: 'fa fa-edit',
    },
    {
      name: '検知条件設定',
      url: '/detectionArea',
      icon: 'fa fa-edit',
    },
  ],
}
